import React from "react";
import Img1 from "./img/img_v2/SLIDE_oxygene-experience-spa-casablanca-2.jpg";   // remplace par ton image
import Img2 from "./img/img_v2/IMG-20220428-WA0012.jpg";
import Img3 from "./img/img_v2/SLIDE-US-VINYL.webp";
// remplace par ton image

const USStretchSection = () => {
  return (
    <div className="usstretch-section">

      {/* ===== BLOC 1 ===== */}
      <div className="usstretch-row" id="#US_STRETCH">
        <div className="usstretch-text">
          <h3 data-aos="fade-right"><span className="subtitle-us">US</span> STRETCH</h3><br/>
          <h5 data-aos="fade-up">En PVC pour plafonds à chaud</h5>

          <p data-aos="fade-up">
            Solutions en toile tendue PVC offrant des solutions innovantes et esthétiques
            pour l’habillage de vos murs et plafonds.
            Grâce à un large choix de couleurs, d’aspects, de textures et de performances
            techniques, <b>US STRETCH</b> s’adapte parfaitement à tous vos projets d’aménagement intérieur.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>✅ Installation rapide et propre</li>
            <li>🔥 Résistance au feu – classement B,s1-d0</li>
            <li>💧 Hydrofuge et inaltérable au chlore</li>
            <li>🎨 Large choix de finitions et de textures</li>
            <li>🛠️ Durabilité et qualité professionnelle</li>
          </ul>
          
        <a data-aos="fade-up" href="/plafond-mur-tendu-maroc" className="learn-more-link">
            En savoir plus <span className="arrow">→</span>
        </a>
        </div>
        

        <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
          <img src={Img1} alt="US Stretch plafond piscine" />
          
        </div>
      </div>

      {/* ===== BLOC 2 (inversé) ===== */}
      <div className="usstretch-row ">
        <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
          <img src={Img2} alt="US Stretch plafond tendu" />
        </div>

        <div className="usstretch-text">
          <h3 data-aos="fade-up-right"><span className="subtitle-us">US</span> TEXTILE</h3><br/>
          <h5 data-aos="fade-up">En textile pour plafonds à froid</h5>

          <p data-aos="fade-up">
            Solutions en toile tendue polyester écologiques et thermorétractables, idéales pour l’habillage moderne de vos plafonds et murs.
Imprimées, lumineuses ou acoustiques, les toiles <b>US TEXTILE</b> améliorent le confort et les performances de l’habitat dans les espaces résidentiels, les commerces, les hôtels et les bureaux.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🧼 Lavable et peut être repeinte</li>
            <li>🔥 Résistante au feu – classée B,s1-d0</li>
            <li>🌱 Éco-labellisée Oeko-Tex</li>
            <li>🎨 Large choix de finitions : imprimée, lumineuse ou acoustique</li>
            <li>🛠️ Solution durable et esthétique</li>
          </ul>
          
        <a data-aos="fade-up" href="/plafond-textile-maroc" className="learn-more-link">
            En savoir plus <span className="arrow">→</span>
        </a>
        </div>
        
      </div>
      {/* ===== BLOC 3 ===== */}
      <div className="usstretch-row">
        <div className="usstretch-text">
          <h3 data-aos="fade-right"><span className="subtitle-us">US</span> PRINT</h3><br/>
          <h5 data-aos="fade-up">Avec impression</h5>

          <p data-aos="fade-up">
            Transformez vos murs et plafonds en véritables supports décoratifs grâce à la toile tendue imprimée.
Cette solution permet de personnaliser vos espaces en créant des ambiances uniques, esthétiques et inspirantes, adaptées aussi bien aux espaces résidentiels qu’aux environnements professionnels.</p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🎨 Création d’une atmosphère agréable et apaisante</li>
            <li>🖌️ Apporte une touche artistique et personnalisée</li>
            <li>♾️ Possibilités de design infinies</li>
            <li>🏠 Idéal pour habitations, commerces, hôtels et bureaux</li>
            <li>✨ Valorisation esthétique de vos espaces</li>
          </ul>

        <a data-aos="fade-up" href="/papier-peint-maroc" className="learn-more-link">
           En savoir plus <span className="arrow">→</span>
        </a>
        </div>
        

        <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
          <img src={Img3} alt="US Stretch plafond piscine" />
        </div>
      </div>
      

    </div>
  );
};

export default USStretchSection;